import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { AgmMap, ControlPosition, MapsAPILoader, MapTypeControlOptions, MouseEvent } from "@agm/core";
import { Events } from "src/app/utils/event-utils";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { sweetAlert } from "../../../utils/swal";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment-timezone";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DispatchCenterService } from "../dashboard-service/dispatch-center-service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { legTypeMap, mapStyles } from "src/app/utils/utils.common";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { OfferedtripsService } from "../../offered-trips/offered-trips-service/offeredtrips.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
import * as _ from 'underscore';
import { DriversService } from "../../drivers/drivers-service/drivers-service";
import { StaffService } from "../../staffs/staff-service/staff.service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";



declare var $;

@Component({
  selector: "app-main",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DispatchDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  legTypeMap: any = legTypeMap;
  duration = 5 * 1000; // 10 seconds
  // Map
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;
  @ViewChild('timer', { static: true }) timer;

  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  agmMap;
  trafficLayer: google.maps.TrafficLayer;
  origin = { lat: 0.0, lng: 0.0 };
  destination = { lat: 0.0, lng: 0.0 };
  latitude: number;
  longitude: number;
  zoom: number = 12;
  styles = mapStyles();
  driverSearch = "";
  notificationSearch = "";
  address: string;
  geoCoder;
  public tripModalObject: any;
  public assignModalObj: any;
  public driverTripModalObj: any;
  public driverTripModalObject: any;
  live = true;
  isFilter = false;

  public drivers = [];
  public superDrivers = [];
  filteredDrivers = [];
  public approachingTrips = [];
  public expiringSoonTrips = [];
  public markedTrips = [];
  notifications = [];
  companyDriverStatus;
  tripId = null;
  reDispatchTripDetail;
  selectedDriver;

  bounds;
  tripsInProgress;
  tripsInProgressObserver;
  selectedApproachingTripOption;
  @ViewChild("search", { static: false })
  public searchElementRef: ElementRef;

  onlineDrivers = 0;
  busyDrivers = 0;
  offlineDrivers = 0;

  isInprogressRoutes = false;
  isMarkedReadyTrips = false;
  isMarkedReadyRoutes = false;
  isExpiredTrips = false;
  isExpiredTripRoutes = false;
  isTraffic = false;
  isApproachingTrips = false;
  isAutoZoom = true;
  openPopup = false;
  showCreateTripModal = true;
  showInprogressTripsSlideout = false;
  driverDetailProfileModal;
  isCTCTrips = false;
  public ctcTripsList: any[] = [];
  ctcTimeFilter: 'all' | '1h' | '2h' | '3h' | 'day' = 'all';
  timeZone;
  showCTCTrips;
  ctcTime = 0;
  showGraph = false;
  selectedMapDriver = '';
  public driverManifestTrips = [];
  public selectedDriverForManifest = null;
  public manifestPoints = [];
  public manifestRoute: any = null;
  public manifestSegments: any[] = [];
  serviceAreaList = [];
  selectedServiceArea = [];
  preServiceAreas = {};
  user;
  isChartModal = false;
  tripDetailModalObj: any;
  completedTripModalObj: any;
  isShowColorInformation = false;
  timeFormat: string = 'HHmm';
  search: any;
  stationManagerList = [];
  selectedStationManagers = [];
  isRdispatcher = false;
  preDriverList = {};
  preStaffList:any = []
  preLevelOfServices = {};
  preSpaceTypes = {};
  selectedCTCTrip: any = null;
  selectedCTCRoute: any = null;
  dayNamesMap = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat'
  };

  constructor(
    private dispatchCenterService: DispatchCenterService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
    private offeredTripsService: OfferedtripsService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private driverService: DriversService,
    private staffService: StaffService,
    private router: Router,
    private levelOfServiceService: LevelOfServiceService,

  ) { }

  ngOnInit() {
    this.getStaffList()
    this.listenSocketEvents();
    this.getServiceAreas();
    this.getLevelOfService();
    this.getSpaceTypes();
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          // user.showCTCTrips = true;
          this.user = user
          if (user.timeFormat) {
            this.timeFormat = user.timeFormat;
          }

          this.showGraph =
            this.user.roles === 'company' &&
            (!this.user.sRoles || this.user.sRoles === 'company');
          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManagers = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.timeZone = user.timeZone;
          this.showCTCTrips = user.showCTCTrips;
          this.getNotificationsList();
          this.timer.start();
          this.emitSocketEvents();
          this.getDrivers();
          this.getTripsInProgress();
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }


  ngAfterViewInit() {
    this.agmElement.mapReady
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((map) => {
        this.agmMap = map;
        this.geoCoder = new google.maps.Geocoder;
        this.getUser();
      });
  }
  onTimerComplete(): void {
    this.timer.init()
    this.emitSocketEvents();
    setTimeout(() => {
      this.timer.start();
    }, 1000);
    this.getTripsInProgress();
    // this.ctcTime += 1;
    // if (this.ctcTime >= 60) { // 5 mins interval for the ctc call 300s / 5s interval = 60
    //   this.ctcTime = 0;
    //   this.fetchCtcTrips();
    // }
  }


  // Drivers Counts
  setDriverCounts() {
    this.onlineDrivers = 0;
    this.busyDrivers = 0;
    this.offlineDrivers = 0;

    this.drivers.forEach((driver) => {
      if (driver.status === "online") {
        this.onlineDrivers++;
      } else if (driver.status === "buzy") {
        this.busyDrivers++;
      } else if (driver.status === "offline") {
        this.offlineDrivers++;
      }
    });

  }

  getTripsInProgress() {

    // isShowAllTrips: false
    const object = {
      status: "inprogress",
      scheduleTime: moment().tz(this.timeZone).startOf('day').toISOString()
    };

    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.tripsInProgress = data;
        }
        this.timer.start();
      });

  }

  // Map Methods
  setBounds() {
    if (!this.isAutoZoom) return;

    if (this.agmMap) {
      let bounds = new google.maps.LatLngBounds();
      const markedReadyTrips = this.expiringSoonTrips.concat(this.markedTrips);

      for (const driver of this.drivers) {
        bounds.extend(
          new window["google"].maps.LatLng(
            driver.latitude ? driver.latitude : 0,
            driver.longitude ? driver.longitude : 0
          )
        );
      }

      if (this.isCTCTrips) {
        for (const trip of this.filteredCtcTripsList) {
          bounds.extend(
            new window["google"].maps.LatLng(
              trip.PULatitude ? trip.PULatitude : 0,
              trip.PULongitude ? trip.PULongitude : 0
            )
          );
        }
      }

      for (const trip of markedReadyTrips) {
        bounds.extend(
          new window["google"].maps.LatLng(
            trip.jobOriginLatitude,
            trip.jobOriginLongitude
          )
        );
      }

      for (const trip of this.driverManifestTrips) {
        if (trip.jobOriginLatitude && trip.jobOriginLongitude) {
          bounds.extend(new window["google"].maps.LatLng(trip.jobOriginLatitude, trip.jobOriginLongitude));
        }
        if (trip.jobDestinationLatitude && trip.jobDestinationLongitude) {
          bounds.extend(new window["google"].maps.LatLng(trip.jobDestinationLatitude, trip.jobDestinationLongitude));
        }
      }

      this.agmMap.setCenter(bounds.getCenter());
      this.agmMap.fitBounds(bounds);
    }
  }

  // Socket Events STARTS




  emitSocketEvents() {
    this.socketService.emit(Events.GET_COMPANY_DRIVER_STATUS);

    // Expired Trips
    if (this.isExpiredTrips) {
      this.socketService.emit(Events.SOON_EXPIRING_TRIPS);
    } else {
      this.expiringSoonTrips = [];
    }

    // Marked Ready Trips
    if (this.isMarkedReadyTrips) {
      this.socketService.emit(Events.GET_MARKED_TRIPS);
    } else {
      this.markedTrips = [];
    }
  }

  listenSocketEvents() {
    this.socketService
      .addListener(Events.GET_COMPANY_DRIVER_STATUS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success && data.drivers && data.drivers.length) {
          this.setupDriverList(data.drivers);
        } else {
          this.drivers = [];
          this.filteredDrivers = [];
          this.selectedStationManagers = [];
          this.stationManagerList = [];
          this.selectedServiceArea = [];
          this.serviceAreaList = [];
        }
      });

    this.socketService
      .addListener(Events.SOON_EXPIRING_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.isExpiredTrips) {
            this.expiringSoonTrips = data.assigns;
            // this.setBounds();
            this.setBounds();
          } else {
            this.expiringSoonTrips = [];
          }
        } else {
          this.expiringSoonTrips = [];
        }
      });

    this.socketService
      .addListener(Events.GET_MARKED_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.isMarkedReadyTrips) {
            this.markedTrips = data.assigns;
            // this.setBounds();
            this.setBounds()
          } else {
            this.markedTrips = [];
          }
        } else {
          this.markedTrips = [];
        }
      });

    this.socketService
      .addListener(Events.GET_APPROCHING_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          this.approachingTrips = [];
          this.approachingTrips.push(...data.assigns);
        } else {
          this.approachingTrips = [];
        }
      });

    this.socketService
      .addListener(Events.SEND_EXPIRE_DISPATCH)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.sucess) {
          this.getNotificationsList();
        }
      });
  }

  setupDriverList(drivers) {
    this.stationManagerList = [];
    this.serviceAreaList = [];

    drivers.forEach(driver => {
      if (this.preDriverList
        && this.preDriverList[driver._id]
        && this.preDriverList[driver._id].stationManager
      ) {
        driver.stationManager = this.preDriverList[driver._id].stationManager;
        if (this.preStaffList && this.preStaffList[driver.stationManager]) {
          this.stationManagerList.push(this.preStaffList[driver.stationManager]);
        }
      } else {
        driver.stationManager = null;
      }

      if (driver.serviceAreas && driver.serviceAreas.length) {
        this.serviceAreaList.push(...driver.serviceAreas);
      }

      if (this.preDriverList
        && this.preDriverList[driver._id]
        && this.preDriverList[driver._id].fleet
      ) {
        driver.fleet = this.preDriverList[driver._id].fleet;
      } else {
        driver.fleet = null;
      }

    });
    this.drivers = drivers;
    this.filteredDrivers = drivers;

    if (this.serviceAreaList && this.serviceAreaList.length) {
      this.serviceAreaList = _.uniq(this.serviceAreaList).map(id => {
        return {
          _id: id,
          name: this.preServiceAreas[id] ? this.preServiceAreas[id].name : id
        };
      }).sort((a, b) => a.name.localeCompare(b.name));
    }

    if (this.stationManagerList && this.stationManagerList.length) {
      this.stationManagerList = _.uniq(this.stationManagerList, '_id');
    }
    this.applyFilters();
    this.setDriverCounts();
    this.setBounds();
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.superDrivers = data.filter(driver => driver.profileRole === 'superdriver' && Array.isArray(driver.associateDrivers));;
          this.preDriverList = data.reduce((obj: any, item: any) => {
            obj[item._id] = item;
            return obj;
          }, {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  associatedDriver(driver) {
    for (const superDriver of this.superDrivers) {
      if (superDriver.associateDrivers.includes(driver._id)) return superDriver;
    }
    return null;
  }

  applyFilters() {
    this.filteredDrivers = this.drivers;

    this.filteredDrivers = this.filteredDrivers.filter(driver => {
      let isStationManagersExist = true;
      let isSearviceAreasExist = true;

      if (this.selectedStationManagers && this.selectedStationManagers.length) {
        isStationManagersExist = driver.stationManager &&
          this.selectedStationManagers.includes(driver.stationManager);
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        isSearviceAreasExist = driver.serviceAreas.some(serviceId =>
          this.selectedServiceArea.includes(serviceId)
        );
      }

      return isStationManagersExist && isSearviceAreasExist;
    });
  }


  // Socket Events END

  // Utils Methods
  getFloatingValues(point) {
    return parseFloat(point)
  }

  expiringSoonTime(trip) {
    const now = moment.utc(new Date()).local().format();
    const expiringSoonTime = moment(trip.scheduleTime);
    return expiringSoonTime.diff(now, "minutes");
  }

  getNameChars(assign) {
    if (assign && assign.priorityClient && assign.priorityClient.displayName) {
      return assign.priorityClient.displayName
        .trim()
        .split(" ")[0];
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.companyDriverStatus);
    this.socketService.removeListener(Events.GET_APPROCHING_TRIPS);
    this.socketService.removeListener(Events.GET_COMPANY_DRIVER_STATUS);
    this.socketService.removeListener(Events.SEND_EXPIRE_DISPATCH);
    this.socketService.removeListener(Events.GET_MARKED_TRIPS);
    this.socketService.removeListener(Events.SOON_EXPIRING_TRIPS);
  }

  // =====================================
  // Unused (Now) & May be reuse later
  // Modals
  openDriverInfo(driver) {
    this.selectedDriver = driver;
  }

  hightlightDriver(driver) {
    if (this.selectedMapDriver === driver._id) {
      this.selectedMapDriver = '';
    } else {
      this.selectedMapDriver = driver._id;
    }
  }

  getDriverAddress() {
    if (this.selectedDriver && this.selectedDriver.latitude && this.selectedDriver.longitude) {
      this.getAddress(this.selectedDriver.latitude, this.selectedDriver.longitude);
    }
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results) {
          this.selectedDriver.address = results[0].formatted_address;
        } else {
          sweetAlert('Alert', 'No Address Found', 'warning', 'Ok')
        }
      } else {
        sweetAlert('Alert', `Geocoder failed due to: ${status}`, 'warning', 'Ok')
      }
    });
  }

  closeDriverAddressWindow(evt) {
    this.selectedDriver = null;
  }

  openTripDetailModal(trip) {

    if (trip.job) {
      this.completedTripModalObj = trip;
    } else {
      this.tripDetailModalObj = trip;
    }
    // this.assignModalObj = object;
  }

  openDriverTripModal(object) {
    this.driverTripModalObject = object;
  }

  tripAssignedResponse(tripStatus) {
    // if (
    //   tripStatus === "Trip Assigned" ||
    //   tripStatus === "Trip Un Assigned" ||
    //   tripStatus === "All Trips Assigned"
    // ) {
    //   // sweetAlert("Success", tripStatus, "success", "OK");
    // } else if (tripStatus !== null) {
    //   sweetAlert("Error", tripStatus, "error", "OK");
    // }
    this.assignModalObj = null;
  }

  onCloseModal(evt) {
    this.assignModalObj = null;
  }

  getNotificationsList() {
    this.dispatchCenterService
      .getNotifications()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.notifications = data;
        }
      });
  }

  onClickProfile(driver) {
    this.driverDetailProfileModal = driver;
  }

  openPushToTalk(driver) {
    this.router.navigate(['/support/push-to-talk'], {
      state: { id: driver._id, name: driver.displayName }
    });
  }

  callDriver(driverId) {
    this.socketService.emit(Events.DRIVER_CALL, {
      to: driverId,
      status: 'join'
    });
  }


  toggleTraffic() {
    this.isTraffic = !this.isTraffic;
    if (this.isTraffic) {
      this.trafficLayer = new google.maps.TrafficLayer();
      this.trafficLayer.setMap(this.agmMap);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

  toggleCTCTrips() {
    this.isCTCTrips = !this.isCTCTrips;
    this.ctcTimeFilter = 'all';
    if (this.isCTCTrips) {
      this.ctcTime = 0;
      this.fetchCtcTrips();
    } else {
      this.selectedCTCRoute = null;
      this.setBounds();
    }
  }
  fetchCtcTrips() {
    if (this.isCTCTrips && this.ctcTime === 0) {
      this.offeredTripsService
        .getCTCTripsList()
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.ctcTripsList = [];
            data.forEach(i => {
              const tripDate = moment.tz(i.DateOfService, this.timeZone).startOf('day');
              const currentDate = moment.tz(this.timeZone);
              if (tripDate.isSameOrBefore(currentDate.startOf('day'), 'day')) {
                i.class = 'today';
                this.ctcTripsList.push(i);
              } else if (tripDate.isSameOrBefore(currentDate.add(1, 'day').startOf('day'), 'day')) {
                i.class = 'tomorrow';
                this.ctcTripsList.push(i);
              }
            });
            this.setBounds();
          }
        });

    }
  }

  getCtcTimeLeft(trip: any): string {
    if (trip.class !== 'today' || !trip.DateOfService || !trip.PickupTime) return '';
    const now = moment.tz(this.timeZone);
    const dateOnly = trip.DateOfService.split(' ')[0];
    const tripTime = moment.tz(`${dateOnly} ${trip.PickupTime}`, "YYYY-MM-DD HH:mm", this.timeZone);
    const diffMins = tripTime.diff(now, 'minutes');

    if (diffMins < 0) {
      return 'Started';
    } else if (diffMins < 60) {
      return `${diffMins}m`;
    } else {
      const hrs = Math.floor(diffMins / 60);
      const mins = diffMins % 60;
      return `${hrs}h ${mins}m`;
    }
  }

  drawCTCRoute(trip) {
    if (this.selectedCTCRoute && this.selectedCTCRoute.tripId === trip.TripLegId) {
      this.selectedCTCRoute = null;
      return;
    }

    this.selectedCTCRoute = {
      tripId: trip.TripLegId,
      origin: { lat: this.getFloatingValues(trip.PULatitude), lng: this.getFloatingValues(trip.PULongitude) },
      destination: { lat: this.getFloatingValues(trip.DOLatitude), lng: this.getFloatingValues(trip.DOLongitude) },
      renderOptions: { polylineOptions: { strokeColor: '#eab308', strokeWeight: 5 } }
    };
  }

  ctcRequest(trip, index) {
    const payload = {
      TriplegId: trip.TripLegId,
    }
    this.offeredTripsService
      .putCTCTripClaim(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.message === 'Created') {
            this.ctcTripsList.splice(index, 1);
          }
        }
      });
  }

  claimTable(trip, index) {
    if (!trip.StandingOrderDays) {
      sweetAlert(`<div class= 'text-main-danger'>Warning</div>`, 'If you reroute these trips once you have claimed them, your ability to use this feature may be suspended. Are you sure you want to claim these trips?', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            this.ctcRequest(trip, index);
          }
        })
    }
    else {
      sweetAlert(`<div> <div class= 'text-main-danger'> You are claiming a standing order trip. By doing so, you are agreeing to take the standing order on all scheduled days which are: ${this.getStandingOrderDayNames(trip.StandingOrderDays)} </div> <div class= 'text-main'> Leg A: ${trip.PickupTime} - ${trip.PickupAddress}  Leg B: ${trip.PickupTime} - ${trip.DropoffAddress} </div> </div>`, `If you reroute these trips once you have claimed them, your ability to use this feature may be suspended. Are you sure you want to claim these trips?`, 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            this.ctcRequest(trip, index);
          }
        })
    }
  }

  ctcFilterByDate() {
  }

  openDriverTripDetailModal(id) {
    this.driverTripModalObj = id;
  }

  closeModal(evt) {
    this.driverTripModalObj = null;
  }

  openGraphModal() {
    this.isChartModal = true;
  }

  showDriverTripsOnMap(driverId) {
    if (this.selectedDriverForManifest === driverId) {
      this.clearManifestFromMap();
      return;
    }

    this.selectedDriverForManifest = driverId;
    const payload = {
      driverId: driverId,
      scheduleTime: moment().tz(this.timeZone).startOf('day').toISOString(),
      status: 'all',
      isTrack: true
    }

    this.dispatchCenterService.getDriverTrips(payload).subscribe(data => {
      if (data && data.assigns && data.assigns.length) {
        this.driverService.getDriverProfile(driverId).subscribe(driver => {
          const points = [];

          // 1. Add Garage Start Point
          if (driver && driver.startingPointAddress && driver.startingPointAddress.latitude) {
            points.push({
              type: 'GARAGE',
              latitude: driver.startingPointAddress.latitude,
              longitude: driver.startingPointAddress.longitude,
              address: driver.startingPointAddress.address,
              time: null,
              trip: { priorityClient: { displayName: 'Garage' } }
            });
          }

          // 2. Add Pickup and Dropoff Points
          data.assigns.forEach((trip, index) => {
            if (trip.status === 'cancelled' && !trip.job) return;

            points.push({
              type: 'PICKUP',
              latitude: trip.jobOriginLatitude,
              longitude: trip.jobOriginLongitude,
              address: trip.jobOriginAddress,
              time: trip.scheduleTime,
              trip: trip,
              tripIndex: index + 1
            });

            if (trip.status !== 'cancelled') {
              points.push({
                type: 'DROPOFF',
                latitude: trip.jobDestinationLatitude,
                longitude: trip.jobDestinationLongitude,
                address: trip.jobDestinationAddress,
                time: trip.appointmentTime,
                trip: trip,
                tripIndex: index + 2
              });
            }

          });

          // 3. Sort by time (keep garage first)
          this.manifestPoints = points.sort((a, b) => {
            if (a.type === 'GARAGE') return -1;
            if (b.type === 'GARAGE') return 1;
            return moment(a.time).valueOf() - moment(b.time).valueOf();
          });

          // 4. Build single continuous route
          if (this.manifestPoints.length >= 2) {
            this.manifestRoute = {
              origin: {
                lat: this.getFloatingValues(this.manifestPoints[0].latitude),
                lng: this.getFloatingValues(this.manifestPoints[0].longitude)
              },
              destination: {
                lat: this.getFloatingValues(this.manifestPoints[this.manifestPoints.length - 1].latitude),
                lng: this.getFloatingValues(this.manifestPoints[this.manifestPoints.length - 1].longitude)
              },
              waypoints: this.manifestPoints.slice(1, -1).map(p => ({
                location: {
                  lat: this.getFloatingValues(p.latitude),
                  lng: this.getFloatingValues(p.longitude)
                },
                stopover: true
              }))
            };
          }

          // Build segments for color coding
          this.manifestSegments = [];
          for (let i = 0; i < this.manifestPoints.length - 1; i++) {
            const current = this.manifestPoints[i];
            const next = this.manifestPoints[i + 1];
            const segmentColor = next.type === 'GARAGE' ? '#6366f1' : this.getTripStatusColor(next.trip);
            this.manifestSegments.push({
              origin: {
                lat: this.getFloatingValues(current.latitude),
                lng: this.getFloatingValues(current.longitude)
              },
              destination: {
                lat: this.getFloatingValues(next.latitude),
                lng: this.getFloatingValues(next.longitude)
              },
              color: segmentColor,
              renderOptions: {
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: segmentColor,
                  strokeWeight: 7,
                  icons: [{
                    icon: {
                      path: 'M -7.5 6.75 L 0 -0.75 L 7.5 6.75 M -7.5 0.75 L 0 -6.75 L 7.5 0.75',
                      scale: 0.3,
                      fillOpacity: 1,
                      fillColor: '#ffffff',
                      strokeColor: '#ffffff',
                      strokeWeight: 1.5
                    },
                    offset: '10%',
                    repeat: '100px'
                  }]
                }
              }
            });
          }

          this.driverManifestTrips = data.assigns;
          this.setBounds();
        });
      } else {
        this.clearManifestFromMap();
        sweetAlert('Info', 'No manifest found for this driver', 'info', 'OK');
      }
    }, err => {
      this.clearManifestFromMap();
      sweetAlert('Error', err, 'error', 'OK');
    });
  }

  clearManifestFromMap() {
    this.driverManifestTrips = [];
    this.selectedDriverForManifest = null;
    this.manifestPoints = [];
    this.manifestRoute = null;
    this.manifestSegments = [];
  }

  getTripStatusColor(trip) {
    if (trip.status === 'cancelled') return '#94a3b8'; // Slate 400
    if (trip.status === 'finished' || trip.jobStatus === 'completed') return '#38bdf8'; // Sky 400
    if (trip.jobStatus === 'started') return '#f87171'; // Red 400
    if (trip.jobStatus === 'arrived') return '#fb923c'; // Orange 400
    if (trip.jobStatus === 'onway') return '#facc15'; // Yellow 400
    if (trip.status === 'offered' || trip.status === 'accepted') return '#4ade80'; // Green 400
    return '#60a5fa'; // Blue 400
  }

  getStaffList() {
    this.staffService.getStaffList()
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj: any, item: any) => {
            obj[item._id] = item;
            return obj;
          }, {});
        }
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getStandingOrderDayNames(standingOrderDays): string {
    if (!standingOrderDays) return 'N/A';
    return standingOrderDays.split(',').map((day:any) => this.dayNamesMap[day]).join(', ')
  }

  setCtcTimeFilter(filter: 'all' | '1h' | '2h' | '3h' | 'day') {
    this.ctcTimeFilter = filter;
    this.setBounds();
  }

  get filteredCtcTripsList() {
    if (this.ctcTimeFilter === 'all') return this.ctcTripsList;

    if (this.ctcTimeFilter === 'day') {
      return this.ctcTripsList.filter(trip => trip.class === 'today');
    }

    const ctcTimeFilterMins: { [key: string]: number } = { '1h': 60, '2h': 120, '3h': 180 };
    const now = moment.tz(this.timeZone);
    const minutesToEndOfDay = moment.tz(this.timeZone).endOf('day').diff(now, 'minutes');
    const windowMins = Math.min(ctcTimeFilterMins[this.ctcTimeFilter], minutesToEndOfDay);

    return this.ctcTripsList.filter(trip => {
      if (trip.class !== 'today') return false;
      const diffMins = this.getCtcMinutesToPickup(trip);
      trip.diffMins = diffMins;
      return diffMins !== null && diffMins >= 0 && diffMins <= windowMins;
    });
  }

  getCtcMinutesToPickup(trip: any): number | null {
    if (!trip.DateOfService || !trip.PickupTime) return null;
    const now = moment.tz(this.timeZone);
    const dateOnly = trip.DateOfService.split(' ')[0];
    const tripTime = moment.tz(`${dateOnly} ${trip.PickupTime}`, "YYYY-MM-DD HH:mm", this.timeZone);
    return Math.floor(tripTime.diff(now, 'seconds') / 60);
  }

}
